import React from "react";
import { useFormHandlerContext } from "../../../../controllers/formController";
import FormEntitySelectionField from "../../fields/basic/EntitySelectionField";
import {
  EntitySelectionProps,
  NodeEntity,
} from "../../../entitiesReferences/EntitySelectionInput";
import { SystemEntityCollections } from "../../../../shared/enums/shared-enums";
import FormEntityReferenceStaticField from "../../fields/basic/EntityReferenceStaticField";

interface FormConnectionHeaderProps<
  TSource extends NodeEntity,
  TDestination extends NodeEntity,
> {
  direction: "inbound" | "outbound";
  fromLabel: string;
  fromEntityCollection: SystemEntityCollections;
  toLabel: string;
  toEntityCollection: SystemEntityCollections;
  renderFromEntitySelection: (
    props: EntitySelectionProps<TSource>
  ) => React.ReactElement;
  renderToEntitySelection: (
    props: EntitySelectionProps<TDestination>
  ) => React.ReactElement;
}

export const FormConnectionHeader = <
  TSource extends NodeEntity,
  TDestination extends NodeEntity,
>({
  direction,
  fromLabel,
  fromEntityCollection,
  toLabel,
  toEntityCollection,
  renderFromEntitySelection,
  renderToEntitySelection,
}: FormConnectionHeaderProps<TSource, TDestination>) => {
  const { isCreateMode, isProcessing } = useFormHandlerContext();

  return (
    <>
      {isCreateMode && direction === "inbound" ? (
        <FormEntitySelectionField
          name="fromDoc"
          label={`From ${fromLabel}`}
          placeholder={`Select ${fromLabel}`}
          entityCollection={fromEntityCollection}
          renderEntitySelection={renderFromEntitySelection}
          required
          disabled={isProcessing}
        />
      ) : (
        <FormEntityReferenceStaticField
          name="fromDoc"
          label={`From ${fromLabel}`}
          entityCollection={fromEntityCollection}
        />
      )}
      {isCreateMode && direction === "outbound" ? (
        <FormEntitySelectionField
          name="toDoc"
          label={`To ${toLabel}`}
          placeholder={`Select ${toLabel}`}
          entityCollection={toEntityCollection}
          renderEntitySelection={renderToEntitySelection}
          required
          disabled={isProcessing}
        />
      ) : (
        <FormEntityReferenceStaticField
          name="toDoc"
          label={`To ${toLabel}`}
          entityCollection={toEntityCollection}
        />
      )}
    </>
  );
};

export default FormConnectionHeader;
